import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { isEmpty } from 'check-tool';

import { getLanguage } from 'common/i18n';

import MenuTop from 'components/MenuTop';
import MenuLeft from 'components/MenuLeft';
import { AuthContext } from 'AuthProvider';
import NotificationCreateMagicBall from './NotificationCreateMagicBall';
import NotificationListMagicBall from './NotificationListMagicBall';
import NotificationCreateIQuestion from './NotificationCreateIQuestion';
import NotificationListIQuestion from './NotificationListIQuestion';
import { getNotificationList } from 'backend/MagicBall/Notification';
import { getNotificationList as getNotificationListIQuestion } from 'backend/IQuestion/Notification';

const NotificationItemPage = (props) => {
  const [nameApp, setNameApp] = useState('');
  const [isCreateMode, setIsCreateMode] = useState('none');
  const [list, setList] = useState(null);

  const lang = getLanguage();
  const { id } = props.match.params;

  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    if (id === 'iquestion') {
      setNameApp('iQuestion Quiz');

      //get list of notifications
      getNotificationListIQuestion()
        .then((result) => {
          setList(result);
        })
        .catch(() => {
          setList(null);
        });
    }
    if (id === 'magic-ball') {
      setNameApp('Magic Ball');

      //get list of notifications
      getNotificationList()
        .then((result) => {
          setList(result);
        })
        .catch(() => {
          setList(null);
        });
    }
  }, []);

  if (isEmpty(currentUser)) {
    return <Redirect to="/signin" />;
  }

  const callSuccess = () => {
    if (id === 'iquestion') {
      //get list of notifications
      getNotificationListIQuestion()
        .then((result) => {
          setList(result);
        })
        .catch(() => {
          setList(null);
        });
    }

    if (id === 'magic-ball') {
      //get list of notifications
      getNotificationList()
        .then((result) => {
          setList(result);
        })
        .catch(() => {
          setList(null);
        });
    }
    setIsCreateMode('none');
  };
 
  return (
    <div>
      <MenuTop lang={lang} user={currentUser} />
      <div className="main-container ace-save-state" id="main-container">
        <MenuLeft lang={lang} user={currentUser} currentPage="notification" />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="breadcrumbs ace-save-state" id="breadcrumbs">
              <ul className="breadcrumb">
                <li>
                  <i className="ace-icon fa fa-home home-icon"></i>
                  <a href="/">Главная</a>
                </li>
                <li>
                  <i className="ace-icon fa fa-comments home-icon"></i>
                  <a href="/notification">Push-сообщения</a>
                </li>
                <li className="active">{nameApp}</li>
              </ul>
            </div>
            <div className="page-content">
              <div className="row">
						  	<div className="col-xs-12 text-right">
                  <button className="btn btn-success" onClick={() => isCreateMode === 'none' ? setIsCreateMode('block') : setIsCreateMode('none')}>
                    {isCreateMode === 'none' ? 'Создать новую PUSH-рассылку' : 'Отменить PUSH-рассылку'}
										<i className="ace-icon fa fa-flask  align-top bigger-125 icon-on-right"></i>
									</button>
                </div>
              </div>
              {id === 'magic-ball' ? <NotificationCreateMagicBall callSuccess={callSuccess} isCreateMode={isCreateMode} /> : null}

              {id === 'magic-ball' && list ? <NotificationListMagicBall list={list} callSuccess={callSuccess} /> : null}

              {id === 'iquestion' ? <NotificationCreateIQuestion callSuccess={callSuccess} isCreateMode={isCreateMode} /> : null}

              {id === 'iquestion' && list ? <NotificationListIQuestion list={list} callSuccess={callSuccess} /> : null}
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationItemPage;
